<script setup lang="ts">
import { XModal, XButton, XLink } from '@clicksign/excalibur';
import { useI18n } from '#i18n';

type PixHelpModalEmit = {
  (e: 'close'): void;
};

const { t } = useI18n();

const emit = defineEmits<PixHelpModalEmit>();

function closeModal() {
  emit('close');
}
</script>

<template>
  <XModal
    is-open
    data-testid="pixHelpModal"
    @close="closeModal"
  >
    <div :class="$style.helpModal">
      <XLink
        to="https://ajuda.clicksign.com/article/122-como-assinar-um-documento"
        :class="$style.link"
        target="_blank"
        icon="external-link"
        icon-position="right"
        is-inline
        data-testid="pixHelpModalLink"
      >
        {{ t('requirement.pix.sign.helpModal.linkText') }}
      </XLink>
      <p>
        {{ t('requirement.pix.sign.helpModal.description') }}
      </p>
    </div>
    <template #actions>
      <XButton
        data-testid="pixHelpModalButton"
        @click="closeModal"
      >
        {{ t('common.close') }}
      </XButton>
    </template>
  </XModal>
</template>

<style lang="scss" module>
.helpModal {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.link {
  margin-bottom: var(--space-regular);
}
</style>
